import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, PlayCircle, Users } from 'lucide-react';
import { formatFa } from './constants';
import type { CompanionCity } from './types';

type CompanionsSpotlightProps = {
  city: CompanionCity;
  onOpenVideo: (city: CompanionCity) => void;
};

const CompanionsSpotlight: React.FC<CompanionsSpotlightProps> = ({ city, onOpenVideo }) => (
  <motion.div
    key={city.id}
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
    className="cp-stories-spotlight"
  >
    <span className="cp-stories-spotlight__accent" style={{ backgroundColor: city.tone }} />
    <span
      className="cp-stories-spotlight__glow pointer-events-none"
      style={{ backgroundColor: city.tone }}
      aria-hidden
    />

    <div className="cp-stories-spotlight__inner">
      <div className="cp-stories-spotlight__main">
        <span
          className="cp-stories-spotlight__avatar"
          style={{ background: `linear-gradient(145deg, ${city.tone}, ${city.tone}99)` }}
        >
          {city.city.slice(0, 1)}
        </span>
        <div className="min-w-0 flex-1 text-right">
          <p className="cp-stories-eyebrow cp-stories-eyebrow--light">شهر انتخاب‌شده روی کره</p>
          <h3 className="cp-stories-spotlight__title">
            {city.city}، {city.country}
          </h3>
          <p className="cp-stories-spotlight__story">{city.story}</p>
          <div className="cp-stories-spotlight__tags">
            <span>
              <MapPin className="h-3.5 w-3.5" />
              {city.region}
            </span>
            <span>
              <Users className="h-3.5 w-3.5" />
              +{formatFa(city.companions)} همراه
            </span>
            <span className="cp-stories-spotlight__tag-muted">{city.highlight}</span>
          </div>
        </div>
      </div>
      <button type="button" onClick={() => onOpenVideo(city)} className="cp-stories-spotlight__cta">
        <PlayCircle className="h-4 w-4" />
        تماشای ویدیو
      </button>
    </div>
  </motion.div>
);

export default CompanionsSpotlight;
